export const LIST_BRANCH_HOLIDAY_REQUEST = 'LIST_BRANCH_HOLIDAY_REQUEST'
export const LIST_BRANCH_HOLIDAY_SUCCESS = 'LIST_BRANCH_HOLIDAY_SUCCESS'
export const LIST_BRANCH_HOLIDAY_FAIL = 'LIST_BRANCH_HOLIDAY_FAIL'

export const LIST_BRANCH_HOLIDAY_RESET = 'LIST_BRANCH_HOLIDAY_RESET'

export const CREATE_BRANCH_HOLIDAY_REQUEST = 'CREATE_BRANCH_HOLIDAY_REQUEST'
export const CREATE_BRANCH_HOLIDAY_SUCCESS = 'CREATE_BRANCH_HOLIDAY_SUCCESS'
export const CREATE_BRANCH_HOLIDAY_FAIL = 'CREATE_BRANCH_HOLIDAY_FAIL'

export const DETAIL_BRANCH_HOLIDAY_REQUEST = 'DETAIL_BRANCH_HOLIDAY_REQUEST'
export const DETAIL_BRANCH_HOLIDAY_SUCCESS = 'DETAIL_BRANCH_HOLIDAY_SUCCESS'
export const DETAIL_BRANCH_HOLIDAY_FAIL = 'DETAIL_BRANCH_HOLIDAY_FAIL'

export const UPDATE_BRANCH_HOLIDAY_REQUEST = 'UPDATE_BRANCH_HOLIDAY_REQUEST'
export const UPDATE_BRANCH_HOLIDAY_SUCCESS = 'UPDATE_BRANCH_HOLIDAY_SUCCESS'
export const UPDATE_BRANCH_HOLIDAY_FAIL = 'UPDATE_BRANCH_HOLIDAY_FAIL'

export const DELETE_BRANCH_HOLIDAY_REQUEST = 'DELETE_BRANCH_HOLIDAY_REQUEST'
export const DELETE_BRANCH_HOLIDAY_SUCCESS = 'DELETE_BRANCH_HOLIDAY_SUCCESS'
export const DELETE_BRANCH_HOLIDAY_FAIL = 'DELETE_BRANCH_HOLIDAY_FAIL'